<template>
  <div class="flex flex-row gap-2 overflow-hidden max-md:max-w-full justify-start">
    <!-- Первый тег - показываем всегда -->
    <div
      v-if="sortedTags.length > 0"
      v-for="tag in sortedTags.slice(0, count)"
      :key="tag.name"
      class="flex items-center overflow-hidden w-fit"
    >
      <!-- flex, чтобы строка тега считалась от 12px спана, а не от 14px обёртки:
           иначе текст садится ниже, чем счётчик «+N» -->
      <div
        class="flex items-center rounded-lg border border-[#D9E5FF] whitespace-nowrap max-md:border max-md:border-border truncate"
        :class="[size === 'small' ? 'py-0.5 px-1.5' : 'px-2 py-1', tagClass]"
      >
        <span
          class="truncate"
          :class="size === 'small' ? '!text-xs' : '!text-sm max-md:!text-xs'"
          >{{ tag.name }}</span
        >
      </div>
    </div>

    <!-- Счетчик остальных тегов - показываем только если тегов больше 1 -->
    <el-popover
      v-if="sortedTags.length > count"
      placement="bottom"
      trigger="hover"
      :show-arrow="false"
      width="auto"
      class=""
    >
      <template #reference>
        <div
          class="rounded-lg border border-[#D9E5FF] whitespace-nowrap cursor-help max-md:border max-md:border-border flex items-center flex-shrink-0"
          :class="[
            size === 'small' ? '!text-xs py-0.5 px-1.5' : 'px-2 py-1 !text-sm max-md:!text-xs',
            tagClass,
          ]"
        >
          +{{ sortedTags.length - count }}
        </div>
      </template>
      <div class="flex flex-wrap gap-1">
        <div
          v-for="tag in sortedTags.slice(count)"
          :key="tag.name"
          class="rounded-lg border border-[#D9E5FF] text-sm max-md:text-xs max-md:py-0.5"
          :class="[
            size === 'small' ? '!text-xs py-0.5 px-1.5' : 'px-2 py-1 !text-sm max-md:!text-xs',
            tagClass,
          ]"
        >
          {{ tag.name }}
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script setup lang="ts">
  import { computed } from "vue";

  interface Tag {
    name: string;
  }

  const props = defineProps<{
    tags: Tag[];
    size?: "small" | "default";
    tagClass?: string;
    count?: number;
  }>();

  const count = computed(() => {
    return props.count || 1;
  });

  const sortedTags = computed(() => {
    return [...props.tags].sort((a, b) => a.name.length - b.name.length);
  });
</script>
